export default __webpack_public_path__ + "static/media/spinner.e8697d57.gif";